// extracted by mini-css-extract-plugin
export default {"link":"hC-z","disabled":"iC-z"};